/* =========================================================================
   Vico Shop and Watch — auto-rotating coverflow shoppable video carousel
   Centre tile enlarges, is centred, and plays; advances every N seconds
   on a continuous loop. Uniform tiles. Products for the centred video
   render below. Add buttons post to /cart/add.js and open the cart drawer.
   ========================================================================= */
(function () {
  'use strict';

  function initSection(root) {
    if (root.__vspInit) return;
    root.__vspInit = true;

    var stage = root.querySelector('[data-vsp-stage]');
    var track = root.querySelector('[data-vsp-track]');
    if (!stage || !track) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-vsp-dot]'));

    var seconds = (parseInt(root.getAttribute('data-seconds'), 10) || 5) * 1000;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';

    var originals = Array.prototype.slice.call(track.querySelectorAll('.vsp-card'));
    var n = originals.length;
    if (n === 0) return;

    var doLoop = n > 1;
    var activeIndex, paused = false, userSoundCard = null, tx = 0, lastMove = 0;
    function nudge() { lastMove = Date.now(); }

    if (doLoop) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      originals.forEach(function (c) { before.appendChild(c.cloneNode(true)); after.appendChild(c.cloneNode(true)); });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
    }
    var cards = Array.prototype.slice.call(track.querySelectorAll('.vsp-card'));

    function origIndex(i) { return doLoop ? ((i - n) % n + n) % n : i; }
    function playSafe(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

    // robust autoplay for iOS: try muted inline, else start on first interaction
    function playActive(v) {
      v.muted = true; v.playsInline = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        var resume = function () {
          v.play().catch(function () {});
          document.removeEventListener('touchstart', resume);
          document.removeEventListener('click', resume);
          document.removeEventListener('scroll', resume);
        };
        document.addEventListener('touchstart', resume, { once: true, passive: true });
        document.addEventListener('click', resume, { once: true });
        document.addEventListener('scroll', resume, { once: true, passive: true });
      });
    }

    // ---- centring (rect based, scale-proof) --------------------------------
    function centerOn(i, animate) {
      var card = cards[i];
      if (!card) return;
      track.style.transition = animate ? 'transform .55s cubic-bezier(.4,0,.2,1)' : 'none';
      var sr = stage.getBoundingClientRect();
      var cr = card.getBoundingClientRect();
      var delta = (sr.left + sr.width / 2) - (cr.left + cr.width / 2);
      tx += delta;
      track.style.transform = 'translateX(' + tx + 'px)';
      if (!animate) { void track.offsetWidth; }
    }

    // ---- embeds ------------------------------------------------------------
    function embedUrl(raw) {
      var url = (raw || '').trim(), m;
      if ((m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/))) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&mute=1&playsinline=1&rel=0&loop=1&playlist=' + m[1];
      if ((m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/))) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1&muted=1&loop=1';
      if ((m = url.match(/tiktok\.com\/.*\/video\/(\d+)/)) || (m = url.match(/tiktok\.com\/embed\/v2\/(\d+)/))) return 'https://www.tiktok.com/embed/v2/' + m[1] + '?autoplay=1';
      if ((m = url.match(/instagram\.com\/(?:reel|reels|p|tv)\/([\w-]+)/))) return 'https://www.instagram.com/reel/' + m[1] + '/embed';
      return url;
    }
    function loadEmbed(media) {
      if (media.querySelector('iframe')) return;
      var f = document.createElement('iframe');
      f.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
      f.setAttribute('allowfullscreen', '');
      f.src = embedUrl(media.getAttribute('data-embed'));
      var img = media.querySelector('img'); if (img) img.style.display = 'none';
      media.appendChild(f);
    }
    function unloadEmbed(media) {
      var f = media.querySelector('iframe');
      if (f) f.remove();
      var img = media.querySelector('img'); if (img) img.style.display = '';
    }

    // ---- centre-only playback ---------------------------------------------
    function playOnly(i) {
      cards.forEach(function (card, idx) {
        var media = card.querySelector('[data-vsp-media]');
        if (!media) return;
        var type = media.getAttribute('data-type');
        var v = media.querySelector('video');
        if (idx === i && autoplay) {
          if (v) { if (card !== userSoundCard) v.muted = true; try { v.currentTime = 0; } catch (e) {} playActive(v); }
          else if (type === 'embed') { loadEmbed(media); }
        } else {
          if (v) { v.pause(); v.muted = true; try { v.currentTime = 0; } catch (e) {} }
          if (type === 'embed') { unloadEmbed(media); }
        }
      });
    }

    function setActive(i, animate) {
      activeIndex = i;
      centerOn(i, animate);
      cards.forEach(function (c, idx) { c.classList.toggle('is-active', idx === i); });
      playOnly(i);
      var oi = origIndex(i);
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === oi); });
    }

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (!doLoop) return;
      if (activeIndex >= 2 * n) setActive(activeIndex - n, false);
      else if (activeIndex < n) setActive(activeIndex + n, false);
    });

    // ---- touch swipe to change video --------------------------------------
    var sx = 0, sy = 0, swiping = false;
    stage.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; sx = t.clientX; sy = t.clientY; swiping = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!swiping) return; swiping = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        nudge();
        if (dx < 0) setActive(activeIndex + 1, true);
        else setActive(activeIndex - 1, true);
      }
    }, { passive: true });

    // ---- interactions ------------------------------------------------------
    cards.forEach(function (card, idx) {
      var media = card.querySelector('[data-vsp-media]');
      if (!media) return;
      media.addEventListener('click', function (e) {
        if (e.target.closest('[data-vsp-mute]')) return;
        nudge();
        if (idx !== activeIndex) { setActive(idx, true); return; }
        var type = media.getAttribute('data-type');
        if (type === 'embed') { paused = true; loadEmbed(media); return; }
        var v = media.querySelector('video'); if (!v) return;
        if (v.paused) {
          // play at all costs on this tap: force muted, load if needed, then play
          v.muted = true;
          try { if (v.readyState < 2) v.load(); } catch (e) {}
          var p = v.play();
          if (p && p.catch) p.catch(function () { try { v.load(); } catch (e) {} v.play().catch(function () {}); });
        } else {
          v.muted = !v.muted;
          userSoundCard = v.muted ? null : card;
          paused = !v.muted;
          if (!v.muted) v.play().catch(function () {});
        }
      });
      var mute = media.querySelector('[data-vsp-mute]');
      if (mute) mute.addEventListener('click', function (e) {
        e.stopPropagation();
        var v = media.querySelector('video'); if (!v) return;
        v.muted = !v.muted;
        userSoundCard = v.muted ? null : card;
        paused = !v.muted;
        if (!v.muted) playSafe(v);
      });
    });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        nudge();
        var i = parseInt(d.getAttribute('data-vsp-dot'), 10);
        setActive(doLoop ? n + i : i, true);
      });
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vsp-add]'); if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var id = btn.getAttribute('data-vsp-add'); if (!id) return;
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }) })
        .then(function (r) { return r.json(); })
        .then(function () { if (window.VicoCart && window.VicoCart.open) { if (window.VicoCart.refresh) window.VicoCart.refresh(); window.VicoCart.open(); } })
        .catch(function () {}).then(function () { btn.disabled = false; });
    });

    // ---- auto-advance ------------------------------------------------------
    if (doLoop) {
      setInterval(function () {
        if (paused || document.hidden) return;
        if (Date.now() - lastMove < seconds) return;        // advance every `seconds`, reset by interaction
        setActive(activeIndex + 1, true);
        lastMove = Date.now();
      }, 500);
    }

    // ---- unlock playback on the very first interaction (iOS) ---------------
    var unlocked = false;
    function unlock() {
      if (unlocked) return; unlocked = true;
      var c = cards[activeIndex]; if (!c) return;
      var v = c.querySelector('video');
      if (v && v.paused) { v.muted = true; v.play().catch(function () {}); }
    }
    ['touchstart', 'click', 'scroll'].forEach(function (ev) {
      document.addEventListener(ev, unlock, { once: true, passive: true });
    });

    // ---- play the centre video when the section scrolls into view ----------
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var c = cards[activeIndex]; if (!c) return;
          var v = c.querySelector('video'); if (!v) return;
          if (en.isIntersecting) { v.muted = (c !== userSoundCard); v.play().catch(function () { v.muted = true; v.play().catch(function () {}); }); }
          else { v.pause(); }
        });
      }, { threshold: 0.35 });
      vio.observe(stage);
    }

    // ---- boot (retry until layout has real widths) -------------------------
    function boot() {
      if (stage.clientWidth === 0 || cards[0].getBoundingClientRect().width === 0) {
        return requestAnimationFrame(boot);
      }
      tx = 0; track.style.transform = 'translateX(0)';
      setActive(doLoop ? n : 0, false);
      lastMove = Date.now();
    }
    requestAnimationFrame(boot);
    window.addEventListener('load', function () { tx = 0; track.style.transform = 'translateX(0)'; setActive(activeIndex == null ? (doLoop ? n : 0) : activeIndex, false); });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { tx = 0; track.style.transform = 'translateX(0)'; setActive(activeIndex, false); }, 150); });
  }

  function initAll() { document.querySelectorAll('[data-vsp]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-vsp]') : null;
    if (el) { el.__vspInit = false; initSection(el); }
  });
})();
